import React, { useEffect, useState } from 'react';
import Validator from 'validatorjs';
import { Button, Col, Form, Row } from 'react-bootstrap';

import { FormControl } from '../../../../facturotopia';
import ObjetoImpDR from '../../support/catalogs/ObjetoImpDR';
import DecimalForGlobals from '../../support/impuestos/DecimalForGlobals';
import ComplementoPagosRules from '../../support/rules/ComplementoPagosRules';
import MonedaPOptions from '../../support/catalogs/complementos/pagos/MonedaPOptions';
import FormaDePagoPOptions from '../../support/catalogs/complementos/pagos/FormaDePagoPOptions';
import ComplementoPagosDRRules from '../../support/rules/complementos/pagos/ComplementoPagosDRRules';
import DocumentoRelacionadoImpuestos from '../../create/complementos/pagos/DocumentoRelacionadoImpuestos';

const PagoForm = (props) => {
  const [data, setData] = useState({});

  useEffect(() => {
    if (props.editing) {
      setData({ ...props.editing, isValid: true });
    }
  }, [props.editing]);

  const getRules = (data) => {
    let rules = {
      ...ComplementoPagosDRRules({
        ...data,
      }),
      ...ComplementoPagosRules(data),
      Monto: ['required', 'decimal:6', 'min:0.000000', 'regex:/^[0-9]{1,18}(.[0-9]{1,6})?$/'],
    };

    delete rules.TipoCambioDR;

    return rules;
  };

  const validate = (data) => {
    const validator = new Validator(data, getRules(data));

    validator.check();

    return validator;
  };

  const handleOnChange = (value) => {
    let newData = {
      ...data,
      ...value,
      ImpuestosDR: value.ObjetoImpDR !== '01' ? data.ImpuestosDR : {},
    };

    const validator = validate(newData);

    setData({
      ...newData,
      isValid: validator.passes(),
    });
  };

  const handleOnImpuestosChange = (impuestos) => {
    const newData = {
      ...data,
      ImpuestosDR: {
        ...data.ImpuestosDR,
        ...impuestos,
      },
    };

    const validator = validate(newData);

    setData({
      ...newData,
      isValid: validator.passes(),
    });
  };

  const isEqualsDivisa = (data) => {
    return data.MonedaDR === (data.MonedaP || data.MonedaDR);
  };

  const getEquivalencia = (data) => {
    return data?.TipoCambioP ?? data?.EquivalenciaDR ?? 1;
  };

  const handleOnAdd = () => {
    props.onAdd(data);

    setData({});
  };

  const rules = getRules(data);

  const monto = DecimalForGlobals.make((data?.ImpSaldoAnt || '0.00') * getEquivalencia(data)).toFixed(6);

  return (
    <Form
      autoComplete="off"
      className="mt-2"
    >
      <div className="py-3 text-upper">
        <strong>Nuevo pago</strong>
      </div>

      <Row>
        <Col
          xs="12"
          sm="6"
          md="4"
        >
          <FormControl
            type="date-picker"
            label="Fecha de pago"
            name="FechaPago"
            help="Formato día/mes/año"
            maxLength="10"
            // autoFocus
            rules={rules.FechaPago}
            value={data.FechaPago}
            onChange={handleOnChange}
          />
        </Col>

        <Col
          xs="12"
          sm="6"
          md="4"
        >
          <FormControl
            type="text"
            label="Hora de pago"
            name="HoraPago"
            mask="00:00"
            placeholder="Ej. 12:00"
            help="Formato horas:minutos, 24 horas"
            maxLength="5"
            rules={rules.HoraPago}
            value={data.HoraPago}
            onChange={handleOnChange}
          />
        </Col>

        <Col
          xs="12"
          sm="6"
          md="4"
        >
          <FormControl
            type="select"
            label="Forma de pago"
            name="FormaDePagoP"
            placeholder=""
            help=""
            rules={rules.FormaDePagoP}
            value={data.FormaDePagoP}
            options={FormaDePagoPOptions}
            onChange={handleOnChange}
          />
        </Col>

        <Col
          xs="12"
          sm="6"
          md="4"
        >
          <FormControl
            type="select"
            label="Moneda"
            name="MonedaP"
            placeholder=""
            help=""
            rules={rules.MonedaP}
            value={data.MonedaP}
            options={MonedaPOptions}
            onChange={handleOnChange}
          />
        </Col>

        <Col
          xs="12"
          sm="6"
          md="4"
        >
          <FormControl
            type="number"
            label="Tipo de cambio"
            name="TipoCambioP"
            placeholder=""
            help=""
            rules={rules.TipoCambioP}
            value={data.TipoCambioP}
            onChange={handleOnChange}
          />
        </Col>

        <Col
          xs="12"
          sm="6"
          md="4"
        >
          <FormControl
            type="number"
            label="Monto a pagar"
            name="Monto"
            placeholder={monto}
            help={
              isEqualsDivisa(data) ? (
                ''
              ) : (
                <>
                  <strong>$</strong>
                  {monto} {data.MonedaP}
                </>
              )
            }
            rules={rules.Monto}
            value={data.Monto}
            onChange={handleOnChange}
          />
        </Col>
      </Row>

      <div className="py-3">
        <strong className="text-muted">Datos de la operación</strong>
      </div>

      <Row>
        <Col
          xs="12"
          sm="6"
          md="4"
        >
          <FormControl
            type="number"
            label="Número de operación"
            name="NumOperacion"
            placeholder=""
            help=""
            rules={rules.NumOperacion}
            value={data.NumOperacion}
            onChange={handleOnChange}
          />
        </Col>

        <Col
          xs="12"
          sm="6"
          md="4"
        >
          <FormControl
            type="text"
            label="Cuenta Ordenante"
            name="CtaOrdenante"
            placeholder=""
            help=""
            rules={rules.CtaOrdenante}
            value={data.CtaOrdenante}
            onChange={handleOnChange}
          />
        </Col>

        <Col
          xs="12"
          sm="6"
          md="4"
        >
          <FormControl
            type="text"
            label="Cuenta Beneficiario"
            name="CtaBeneficiario"
            placeholder=""
            help=""
            rules={rules.CtaBeneficiario}
            value={data.CtaBeneficiario}
            onChange={handleOnChange}
          />
        </Col>
      </Row>

      <Row>
        <Col
          xs="12"
          sm="6"
          md="4"
        >
          <FormControl
            type="select"
            label="Objeto Impuesto DR"
            name="ObjetoImpDR"
            placeholder=""
            help={data.ObjetoImpDR !== '01' ? 'Debes agregar al menos un impuesto' : ''}
            rules={rules.ObjetoImpDR}
            value={data.ObjetoImpDR}
            options={ObjetoImpDR}
            onChange={handleOnChange}
          />
        </Col>
      </Row>

      <DocumentoRelacionadoImpuestos
        data={data}
        onChange={handleOnImpuestosChange}
      />

      <Row>
        <Col>
          <p className="text-muted">Todos los pagos se mostrarán en la tabla de pagos.</p>
        </Col>
      </Row>

      <Row>
        <Col className="text-right">
          <Button
            variant="secondary"
            disabled={!data.isValid}
            onClick={handleOnAdd}
          >
            Agregar Pago
          </Button>
        </Col>
      </Row>
    </Form>
  );
};

export default PagoForm;
